import axios from 'axios'
import { Toast } from 'vant'
import { Indicator } from 'mint-ui'
import { b2bUrls } from './config.js'
import { getCookie } from '../utils/cookie'
import router from '../router'
import store from '../store/index'

/**
 * 提示函数
 * 禁止点击蒙层，显示1秒后关闭
*/

const tip = msg => {
    Toast({
        message: msg,
        duration: 1000,
        forbidClick: true
    })
}

/**
 * 请求失败后的错误统一处理
 * @param {Number} status 请求失败的状态码
*/
const errorHandle = (status, other) => {
    switch (status) {
        case 400:
            tip(other)
            break
        case 401:
            tip('登录失败')
            break
        case 404:
            tip('请求资源不存在')
            break
        case 429:
            router.push({ path: '/b2b/429' })
            break
        case 500:
            tip('网络出小差，请重试')
            break
        default:
            console.log(other)
    }
}

// 创建axios实例
const instance = axios.create({
    baseURL: b2bUrls
})
/**
 * 请求拦截器
 * 每次请求，如果存在token则在请求头中携带token
*/
instance.interceptors.request.use((config) => {
    // 以下两个字段是用于埋点的
    config.headers['Request-Source'] = 1
    config.headers['Backend-Request'] = 'true'
    const token = localStorage.getItem('token') || getCookie('token')
    const refreshToken = localStorage.getItem('refreshToken') || getCookie('refreshToken')
    const comUrl = config.url
    if (token && refreshToken && !comUrl.includes('hbp')) {
        config.headers['Authorization'] = 'Bearer ' + token
        config.headers['Refresh-Token'] = refreshToken
    }
    return config
})
instance.interceptors.response.use((response) => {
    if (response.headers['access-token']) {
        localStorage.setItem('token', response.headers['access-token'])
    }
    if (response.headers['refresh-token']) {
        localStorage.setItem('refreshToken', response.headers['refresh-token'])
    }
    store.commit('CHANGE_NETWORK', true)
    return response
}, function (error) {
    Toast.clear()
    Indicator.close()
    const { response } = error
    // if (error.code == 'ECONNABORTED' && error.message.indexOf('timeout') != -1) {
    //     tip('网络超时，请重试')
    // }
    if (response) {
        // 埋点接口报错的时候，报错信息不进行返回
        if (response.config.url.indexOf('ets/api/event-tracks') != -1) {
            return
        }
        // 请求已发出，但不在2xx范围之类
        errorHandle(response.status, response.data.message)
        return Promise.reject(error)
    } else {
        // 处理断网的情况
        // eg:请求超时或断网时，更新state的network状态
        // network状态在app.vue中控制着一个全局的断网提示组件的显示隐藏
        // 关于断网组件中的刷新重新获取数据，会在断网组件中说明
        if (!window.navigator.onLine) {
            store.commit('CHANGE_NETWORK', false)
        } else {
            return Promise.reject(error)
        }
    }
})

export default instance
